import React from "react";
import BaseButton from "../BaseButton";
import { makeStyles } from "@material-ui/core/styles";

const commonStyles = {
    padding: "12px 40px 12px 40px",
    borderRadius: "100px",
    width: "288px",
    height: "48px",
    textTransform: "none",
};
const useStyles = makeStyles((theme) => ({
    root: {
        color: theme.palette.white,
        background: theme.palette.primary.light,
        boxShadow: theme.shadows[0],
        ...theme.typography.button,
        ...commonStyles,

        "&:hover": {
            background: theme.palette.white,
            color: theme.palette.primary.light,
            border: `1px solid ${theme.palette.primary.light}`,
        },
        "&:active": {
            boxShadow: "none",
        },

        [theme.breakpoints.between(350, 400)]: {
            width: "320px",
        },
        [theme.breakpoints.between(401, 500)]: {
            width: "350px",
        },
        [theme.breakpoints.up(500)]: {
            width: "400px",
        },
    },
}));
const useDisabledStyles = makeStyles((theme) => ({
    root: {
        background: theme.palette.grey.main,
        color: `${theme.palette.white} !important`,
        ...commonStyles,

        [theme.breakpoints.between(350, 550)]: {
            width: "350px",
        },
        [theme.breakpoints.up(600)]: {
            width: "400px",
        },
    },
}));

const ContinueButton = (props) => {
    const styles = useStyles();
    const disabledStyles = useDisabledStyles();
    const buttonStyles = (props.disabled) ? disabledStyles : styles;
    return (
        <BaseButton
            classes={buttonStyles}
            {...props}
        />
    );
};

export default ContinueButton;